import { useSettings } from "../lib/settings";
import { Link, useLocation } from "react-router-dom";
import { Megaphone } from "lucide-react";

export default function PromoStrip() {
  const { settings } = useSettings();
  const loc = useLocation();
  if (!settings?.promo_enabled || !settings?.promo_text) return null;
  if (loc.pathname.startsWith("/admin")) return null;

  const Inner = (
    <div className="flex items-center justify-center gap-2 h-9 px-4 bg-gradient-to-l from-[#EF1B17] via-[#FF3B30] to-[#EF1B17] text-white text-xs md:text-sm font-bold text-center">
      <Megaphone size={14} className="shrink-0" />
      <span className="truncate">{settings.promo_text}</span>
    </div>
  );

  return (
    <div data-testid="promo-strip" className="fixed top-0 inset-x-0 z-[60]">
      {settings.promo_link ? <Link to={settings.promo_link} className="block hover:opacity-90 transition-opacity">{Inner}</Link> : Inner}
    </div>
  );
}
